import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';
import { IScan } from '../interfaces';
import { ScanMapper } from '../mappers';

export type IGetScansRepoResponse = IRepoResponse<200, IScan[]> | IRepoResponse<400 | 500, string>;

export type IGetScansRepo = IRepo<[string], IGetScansRepoResponse>;

export const GetScansRepoType = Symbol.for('GetScansRepo');

@bind(GetScansRepoType)
export class GetScansRepo implements IGetScansRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: string) {
    try {
      const url = urlMaker(`/api/admin/branch_inspections/${id}/scans`, {
        sort_order: 'desc',
        sort_column: 'id',
      });

      const result = await this.httpClient.get({ url });

      if (result.status === 200) {
        const data: IScan[] = result.data.data?.map(ScanMapper.toDomain);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
